export const _global = {
  properCase: string => {
    return string
      ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
      : ''
  },
  formatNumber: number => {
    if (!number) return ""
    if (number.length !== 10) return number
    const numberPattern = /^(\d{3})(\d{3})(\d{4})$/
    const match = number.match(numberPattern)
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`
    }
  },
  renameObject: (o, new_key, old_key) => {
    const dataItem = Object.defineProperty(
      o,
      new_key,
      Object.getOwnPropertyDescriptor(o, new_key)
    )
    delete o[old_key]
    return dataItem
  },

  onlyAlpha: value => {
    const pattern = /^[A-Za-z]+$/
    if (value.match(pattern)) {
      return true
    }
  },
  ping(ip, callback) {
    if (!this.inUse) {
      this.status = 'unchecked'
      this.inUse = true
      // this.callback = callback;
      this.ip = ip
      const _that = this
      this.img = new Image()
      this.img.onload = function () {
        _that.inUse = false
        // _that.callback('responded',);
      }
      this.img.onerror = function (e) {
        if (_that.inUse) {
          _that.inUse = false
          // _that.callback('responded', e);
        }
      }
      this.start = new Date().getTime()
      this.img.src = `http://${ip}`
      this.timer = setTimeout(function () {
        if (_that.inUse) {
          _that.inUse = false
          _that.callback('timeout')
        }
      }, 1500)
    }
  },
}
